// extracted by mini-css-extract-plugin
export default {"Box":"table-cell-module__Box--LRT5E","StyledTableCell":"table-cell-module__StyledTableCell--kWsXD"};